/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */

import { Config } from 'configs';
import React, { useState, useRef, createRef, useEffect, useContext } from 'react';
import { ExclamationCircleIcon, PencilIcon } from '@heroicons/react/solid';
import { Context as LanguagesContext } from 'contexts/languages';
import { Input } from './input';
import { AvailableLanguagesSelectForm } from './_popup_languages';

export const TranslatableInput = ({
  name,
  register,
  error,
  containerClassName,
  labelClassName,
  renderAsTextArea,
  ...props
}) => {
  const { state: languagesState, changeCurrentLanguage, changeLanguageDisplay } = useContext(LanguagesContext);

  const elementsRef = useRef(Config.AVAILABLE_LANGUAGES.map(() => createRef()));
  const [selectedLanguage, setSelectedLanguage] = useState(languagesState.currentLanguage || 'en');
  const [errorMessage, setErrorMessage] = useState(error);

  const [languagesModalOpen, setLanguagesModalOpen] = useState(false);

  useEffect(() => {
    setSelectedLanguage(languagesState.currentLanguage);
  }, [languagesState.currentLanguage]);

  const changeLanguge = (lng) => {
    setSelectedLanguage(lng);
    changeCurrentLanguage(lng);
  };

  useEffect(() => {
    if (error) {
      let errorSet = false;

      for (const [, value] of Object.entries(error)) {
        if (errorSet) {
          return;
        }

        if (value && value.message) {
          errorSet = true;
          setErrorMessage(value.message);
        }
      }
    } else {
      setErrorMessage(undefined);
    }
  }, [error, name]);

  const filteredAvailableLanguages = Config.AVAILABLE_LANGUAGES.filter((x) => languagesState.selectedLanguages && languagesState.selectedLanguages.includes(x));

  return (
    <div className={containerClassName}>
      <ul className="ml-2 flex items-center flex-wrap">
        {filteredAvailableLanguages.map((lng, index) => (
          <li
            style={{
              fontWeight: selectedLanguage === lng ? 'bold' : 'normal',
              color: error && error[lng] ? 'red' : 'black',
              cursor: 'pointer',
            }}
            className={`${labelClassName} mr-1 whitespace-nowrap`}
            ref={elementsRef.current[index]}
            key={`${name}_${lng}_tab`}
            id={`${name}_${lng}_tab`}
            onClick={() => changeLanguge(lng)}
          >
            {lng}{' '}
            <span style={{ fontWeight: 'normal' }}>
              {filteredAvailableLanguages.length - 1 > index && '/'}
            </span>
          </li>
        ))}
        <PencilIcon
          className="h-4 mr-2 text-blue-500 cursor-pointer"
          onClick={() => {
            setLanguagesModalOpen(true);
          }}
        />
      </ul>

      {filteredAvailableLanguages.map((lng) => {
        if (lng === selectedLanguage) {
          const componentNameFull = `${name}.${lng}`;

          return (
            <div className="mt-1 relative rounded-md shadow-sm" key={`${name}_${lng}`}>
              {!renderAsTextArea && (
                <Input type="text" {...register(componentNameFull)} {...props} />
              )}
              {renderAsTextArea && (
                <textarea {...register(componentNameFull)} {...props} rows={3} />
              )}
              {errorMessage && (
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
                </div>
              )}
            </div>
          );
        }

        return null;
      })}
      {errorMessage && (
        <p className="mt-2 text-sm text-red-600" id="email-error">
          {errorMessage}
        </p>
      )}
      <AvailableLanguagesSelectForm
        isOpen={languagesModalOpen}
        closeModal={() => { setLanguagesModalOpen(false); }}
        selectedLanguages={languagesState.selectedLanguages}
        onChange={(lng, selected) => {
          changeLanguageDisplay(lng, selected);
        }}
      />
    </div>
  );
};
